const ProgressFull = {
  type: 'array',
  minItems: 1,
  items: [
    {
      type: 'object',
      properties: {
        type: { type: 'string' },
        total: { type: 'number', exclusiveMinimum: 0 },
        current: { type: 'number', minimum: 0 }
      },
      required: ['type', 'total', 'current']
    }
  ]
};
const Progress = {
  type: 'array',
  minItems: 1,
  items: [
    {
      type: 'object',
      properties: {
        type: { type: 'string' },
        total: { type: 'number', exclusiveMinimum: 0 },
        current: { type: 'number', minimum: 0 }
      }
    }
  ]
};

const CurrencyFull = {
  type: 'object',
  properties: {
    code: { type: 'string' },
    decimals: { type: 'number' }
  },

  required: ['code', 'decimals']
};

const Currency = {
  type: 'object',
  properties: {
    code: { type: 'string' },
    decimals: { type: 'number' }
  }
};

const Games = {
  type: 'array',
  minItems: 1,
  items: [
    {
      type: 'object',
      properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        link: { type: 'string' }
      },
      required: ['id', 'name']
    }
  ]
};

const RewardFull = {
  type: 'array',
  minItems: 1,
  items: [
    {
      type: 'object',
      properties: {
        type: { type: 'string' },
        amount: { type: 'number', exclusiveMinimum: 0 },
        games: Games
      },
      required: ['type', 'amount']
    }
  ]
};
const Reward = {
  type: 'array',
  minItems: 1,
  items: [
    {
      type: 'object',
      properties: {
        type: { type: 'string' },
        amount: { type: 'number', exclusiveMinimum: 0 },
        games: Games
      }
    }
  ]
};

const TimeFull = {
  type: 'object',
  properties: {
    startedAt: { type: 'string' },
    finishedAt: { type: 'string' },
    resultedAt: { type: 'string' }
  },
  required: ['startedAt', 'finishedAt']
};
const Time = {
  type: 'object',
  properties: {
    startedAt: { type: 'string' },
    finishedAt: { type: 'string' },
    resultedAt: { type: 'string' }
  }
};

const achievement_full = {
  $id: 'achievement_full',
  type: 'object',
  properties: {
    id: { type: 'number' },
    type: { const: 'achievement' },
    participatingGames: Games,
    currency: CurrencyFull,
    info: {
      type: 'object',
      properties: {
        status: { type: 'string' }
      },

      required: ['status']
    },
    conditions: {
      type: 'object',
      properties: {
        minBet: { type: 'number', minimum: 0 }
      },
      required: ['minBet']
    },
    progress: ProgressFull,
    rewards: RewardFull,
    time: TimeFull
  },
  required: ['type', 'conditions', 'progress', 'rewards', 'time', 'id', 'info', 'participatingGames', 'currency']
};
const achievement = {
  $id: 'achievement',
  type: 'object',
  properties: {
    id: { type: 'number' },
    type: { const: 'achievement' },
    participatingGames: Games,
    currency: Currency,
    info: {
      type: 'object',
      properties: {
        status: { type: 'string' }
      },

      required: ['status']
    },
    conditions: {
      type: 'object',
      properties: {
        minBet: { type: 'number', minimum: 0 }
      }
    },
    progress: Progress,
    rewards: Reward,
    time: Time
  },
  required: ['id', 'type']
};
const achievementCounter_full = {
  $id: 'achievementCounter_full',
  type: 'object',
  properties: {
    id: { type: 'number' },
    type: { const: 'achievementCounter' },
    participatingGames: Games,
    currency: CurrencyFull,
    info: {
      type: 'object',
      properties: {
        rewardsTotal: { type: 'number', exclusiveMinimum: 0 },
        status: { type: 'string' }
      },
      required: ['rewardsTotal', 'status']
    },
    conditions: {
      type: 'object',
      properties: {
        minBet: { type: 'number', minimum: 0 },
        rewardsLeft: { type: 'number', minimum: 0 }
      },
      required: ['minBet']
    },
    progress: ProgressFull,
    rewards: RewardFull,
    time: TimeFull
  },
  required: ['type', 'conditions', 'progress', 'reward', 'time', 'info', 'id', 'participatingGames', 'currency']
};
const achievementCounter = {
  $id: 'achievementCounter',
  type: 'object',
  properties: {
    id: { type: 'number' },
    type: { const: 'achievementCounter' },
    participatingGames: Games,
    currency: CurrencyFull,
    info: {
      type: 'object',
      properties: {
        rewardsTotal: { type: 'number', exclusiveMinimum: 0 },
        status: { type: 'string' }
      }
    },
    conditions: {
      type: 'object',
      properties: {
        minBet: { type: 'number', minimum: 0 },
        rewardsLeft: { type: 'number', minimum: 0 }
      }
    },
    progress: ProgressFull,
    rewards: RewardFull,
    time: TimeFull
  },

  required: ['id', 'type']
};
const prizeSpins_full = {
  $id: 'prizeSpins_full',
  type: 'object',
  properties: {
    type: { enum: ['freeSpins', 'freeRounds', 'bonusGame'] },
    rounds: { type: 'integer', exclusiveMinimum: 0 },
    roundsLeft: { type: 'integer', minimum: 0 },
    games: Games,
    bet: { type: 'number', minimum: 0 },
    wins: { type: 'number', minimum: 0 },
    id: { type: 'string' },
    promotionId: { type: 'number' },
    time: {
      type: 'object',
      properties: {
        expiredAt: { type: 'string' }
      },
      required: ['expiredAt']
    }
  },
  required: ['type', 'rounds', 'roundsLeft', 'games', 'bet', 'wins', 'id', 'promotionId', 'time']
};
const prizeSpins = {
  $id: 'prizeSpins',
  type: 'object',
  properties: {
    type: { enum: ['freeSpins', 'freeRounds', 'bonusGame'] },
    id: { type: 'string' },
    rounds: { type: 'integer', exclusiveMinimum: 0 },
    roundsLeft: { type: 'integer', minimum: 0 },
    games: Games,
    bet: { type: 'number', minimum: 0 },
    wins: { type: 'number', minimum: 0 },
    promotionId: { type: 'number' },
    time: {
      type: 'object',
      properties: {
        expiredAt: { type: 'string' }
      },
      required: ['expiredAt']
    }
  },

  required: ['id', 'type']
};
const payment = {
  $id: 'payment',
  type: 'object',
  properties: {
    type: { const: 'payment' },
    id: { type: 'string' },
    amount: { type: 'number', minimum: 0 },
    promotionId: { type: 'number' }
  },
  required: ['type', 'amount', 'id']
};
const tournament_full = {
  $id: 'tournament_full',
  type: 'object',
  properties: {
    id: { type: 'number' },
    type: { const: 'tournament' },
    info: {
      type: 'object',

      required: ['prizes', 'points', 'status'],
      properties: {
        prizes: {
          type: 'array',
          items: [
            {
              type: 'object',
              properties: {
                to: { type: 'integer', minimum: 0 },
                from: { type: 'integer', minimum: 0 },
                prize: RewardFull
              },

              required: ['to', 'from', 'prize']
            }
          ]
        },
        points: {
          type: 'object',
          properties: {
            bet: { type: 'number', minimum: 0 },
            win: { type: 'number', minimum: 0 },
            round: { type: 'number', minimum: 0 },
            winToBet: { type: 'number', minimum: 0 }
          }
        },
        status: { type: 'string' }
      }
    },
    conditions: {
      type: 'object',
      properties: {
        minBet: { type: 'number', minimum: 0 },
        minRounds: { type: 'number', minimum: 0 }
      },
      required: ['minBet', 'minRounds']
    },
    time: TimeFull,
    participatingGames: Games,
    currency: Currency
  },

  required: ['type', 'info', 'conditions', 'time', 'id', 'participatingGames']
};
const tournament = {
  $id: 'tournament',
  type: 'object',
  properties: {
    type: { const: 'tournament' },
    id: { type: 'number' },
    info: {
      type: 'object',

      properties: {
        prizes: {
          type: 'array',
          items: [
            {
              type: 'object',
              properties: {
                to: { type: 'integer', minimum: 0 },
                from: { type: 'integer', minimum: 0 },
                prize: RewardFull
              },

              required: ['to', 'from', 'prize']
            }
          ]
        },
        points: {
          type: 'object',
          properties: {
            bet: { type: 'number', minimum: 0 },
            win: { type: 'number', minimum: 0 },
            round: { type: 'number', minimum: 0 },
            winToBet: { type: 'number', minimum: 0 }
          }
        },
        status: { type: 'string' }
      }
    },
    conditions: {
      type: 'object',
      properties: {
        minBet: { type: 'number', minimum: 0 },
        minRounds: { type: 'number', minimum: 0 }
      }
    },
    time: Time,
    participatingGames: Games,
    currency: Currency
  },
  required: ['id', 'type']
};

const get_tournament_players = {
  $id: 'tournamentTable',
  type: 'object',
  properties: {
    players: {
      type: 'array',
      items: [
        {
          type: 'object',
          properties: {
            place: { type: 'number' },
            score: { type: 'number' },
            player: { type: 'string' }
          }
        }
      ]
    },
    id: { type: 'string' }
  }
};
const schemas: any[] = [
  {
    $id: 'login',
    type: 'object',
    properties: {
      command: { type: 'string' },
      data: {
        type: 'object',
        properties: {
          promotions: {
            type: 'array'
          },
          prizes: {
            type: 'array'
          },
          requirements: {
            type: 'object',
            properties: {
              sendZero: { type: 'boolean' },
              platformName: { type: 'string' }
            }
          }
        },
        required: ['promotions', 'prizes', 'requirements']
      }
    },
    required: ['command', 'data']
  },
  {
    $id: 'update',
    type: 'object',
    properties: {
      command: { type: 'string' },
      data: {
        discriminator: { propertyName: 'type' },
        oneOf: [achievementCounter, achievement, tournament, prizeSpins, payment]
      }
    },
    required: ['command', 'data']
  },
  {
    $id: 'create',
    type: 'object',
    properties: {
      command: { type: 'string' },
      data: {
        discriminator: { propertyName: 'type' },
        oneOf: [achievement_full, achievementCounter_full, tournament_full, prizeSpins_full, payment]
      }
    },
    required: ['command', 'data']
  },
  {
    $id: 'delete',
    type: 'object',
    properties: {
      command: { type: 'string' },
      data: {
        type: 'object',
        properties: {
          type: { type: 'string' },
          id: { type: ['string', 'number'] }
        },
        required: ['type', 'id']
      }
    },
    required: ['command', 'data']
  },
  {
    $id: 'get',
    properties: {
      query: { type: 'string' },
      command: { type: 'string' },
      data: { type: 'object' }
    },
    required: ['command', 'data', 'query']
  },
  {
    $id: 'ping',
    type: 'object',
    properties: {
      ping: { type: 'string' }
    }
  },
  get_tournament_players
];

export { schemas };
